import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import service from '../../../apis/service';
import { apiEndpoints } from '../../../constants/apiEndpoints';
import { ErrorToast, notifySuccess } from '../../utils/Utils';
import { setAdminUsersList, setAdminUserDetails, showProgress } from '../../../redux/actions/DealershipActions';

const useAdminUsers = () => {
  const dispatch = useDispatch();

  const getDetail = useCallback(
    async (id) => {
      if (!id && id !== 0) return;
      try {
        dispatch(showProgress(true));
        const res = await service.get(apiEndpoints.ADMIN_USER_DETAIL.replace('ID', id));
        dispatch(setAdminUserDetails(res));
      } catch (e) {
        ErrorToast(e);
      } finally {
        dispatch(showProgress(false));
      }
    },
    [dispatch],
  );

  const getList = useCallback(
    async (activeId = null) => {
      try {
        dispatch(showProgress(true));
        const res = await service.get(apiEndpoints.ADMIN_USER_LIST);
        const list = res?.data || [];
        dispatch(setAdminUsersList(list, activeId));
      } catch (e) {
        ErrorToast(e);
      } finally {
        dispatch(showProgress(false));
      }
    },
    [dispatch],
  );

  const updateAdmin = useCallback(
    async (id, body) => {
      try {
        dispatch(showProgress(true));
        await service.post(apiEndpoints.ADMIN_USER_UPDATE.replace('ID', id), body);
        notifySuccess('Admin updated successfully');
        await getList(id);
        return true;
      } catch (e) {
        ErrorToast(e);
        return false;
      } finally {
        dispatch(showProgress(false));
      }
    },
    [dispatch, getList],
  );

  const createAdmin = useCallback(
    async (body) => {
      try {
        dispatch(showProgress(true));
        const res = await service.post(apiEndpoints.ADMIN_USER_CREATE, body);
        notifySuccess('Admin created successfully');
        await getList(res?.id ?? null);
        return true;
      } catch (e) {
        ErrorToast(e);
        return false;
      } finally {
        dispatch(showProgress(false));
      }
    },
    [dispatch, getList],
  );

  return { getList, getDetail, updateAdmin, createAdmin };
};

export default useAdminUsers;
